module.exports = __webpack_public_path__ + "static/media/home_carrucel2.4b768362.png";